import { useMutation } from 'react-query'
import { postAPI } from 'framework/api/http'

interface AgeingDataCountInterface {
  partnerCodes?: any
  orderTypes?: any
}

export const useGetAgeingDataCount = () => {
  const mutate = useMutation(
    ({ partnerCodes, orderTypes }: AgeingDataCountInterface) => {
      return postAPI(`MWDashboard/GetAgeingOrderDetails`, {
        partnerCodes: partnerCodes || [],
        orderTypes: orderTypes || [],
      })
    },
  )

  return mutate
}

export default useGetAgeingDataCount
